// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"400f0bc7","453":"a09101ea","751":"d2a156f1"}[chunkId] + ".chunk.js";
};